import ModelFactory from 'business/models/ModelFactory';
import { TreeService } from 'business/services/TreeService';
import { BaseTreeDataSupplier } from './BaseTreeDataSupplier';

class OptimizationNewExpTreeDataSupplier implements BaseTreeDataSupplier {
  async getTreeNodes(id: any) {
    const ser: TreeService = ModelFactory(TreeService, false, true);
    const children = await ser.getOptimizationNewExpTreeNodesService(id);

    if (children === null) {
      return null;
    }

    return children;
  }
}

export default OptimizationNewExpTreeDataSupplier;
